var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6454 15.4424C14.5609 15.4303 14.4521 15.4303 14.3554 15.4424C12.2288 15.3699 10.5371 13.6299 10.5371 11.4912C10.5371 9.30408 12.3013 7.52783 14.5004 7.52783C16.6875 7.52783 18.4638 9.30408 18.4638 11.4912C18.4517 13.6299 16.7721 15.3699 14.6454 15.4424Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6438 23.4178C20.493 25.3873 17.6413 26.5836 14.4996 26.5836C11.358 26.5836 8.5063 25.3873 6.35547 23.4178C6.4763 22.2819 7.2013 21.1703 8.49422 20.3003C11.8051 18.1011 17.2184 18.1011 20.5051 20.3003C21.798 21.1703 22.523 22.2819 22.6438 23.4178Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 26.5832C21.1733 26.5832 26.5832 21.1733 26.5832 14.4998C26.5832 7.8264 21.1733 2.4165 14.4998 2.4165C7.8264 2.4165 2.4165 7.8264 2.4165 14.4998C2.4165 21.1733 7.8264 26.5832 14.4998 26.5832Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.9c285312f491cbeea29ad3768cb1b621.svg";
export { ForwardRef as ReactComponent };